import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'
import { axiosInstance } from './axios'

class TokenRefresher {
    private static instance: TokenRefresher
    private refreshPromise: Promise<string | void> | null = null

    private constructor() {}

    public static getInstance(): TokenRefresher {
        if (!TokenRefresher.instance) {
            TokenRefresher.instance = new TokenRefresher()
        }
        return TokenRefresher.instance
    }

    /**
     * Renova o JWT pelo refresh token. Na falha faz logoff, exceto troca de
     * funcionário recusada sem 401; `redirecionar` falso mantém o usuário na
     * página atual (ex.: link público aberto).
     * `funcionarioId` troca o cliente do token para o desse funcionário.
     */
    public async refreshToken(
        redirecionar = true,
        funcionarioId?: number,
    ): Promise<string | void> {
        const isTroca = funcionarioId !== undefined
        if (this.refreshPromise && !isTroca) return this.refreshPromise
        // O refresh token rotaciona: usar o cookie antigo em paralelo daria 401.
        while (this.refreshPromise)
            await this.refreshPromise.catch(() => undefined)

        const refreshToken = Cookies.get('refreshToken')
        if (!refreshToken) return this.logoff()

        const promise: Promise<string | void> = axiosInstance
            .request({
                url: '/v1/auth/refresh',
                method: 'POST',
                data: { refreshToken, funcionarioId },
            })
            .then((response: any) => {
                Cookies.set('JWT', response.token, {
                    expires: 1,
                    sameSite: 'lax',
                })
                this.salvarRefreshToken(response.refreshToken)
                return response.token as string
            })
            .catch(e => {
                console.error(e)
                // Troca rejeitada (funcionário inválido) não consome o refresh token.
                if (isTroca && e?.statusCode !== 401) return
                this.logoff(redirecionar)
            })
            .finally(() => {
                if (this.refreshPromise !== promise) return
                this.refreshPromise = null
            })
        this.refreshPromise = promise

        return promise
    }

    /** Grava o cookie com a validade do próprio token: 15 dias, ou 1 sem "lembre-se de mim". */
    public salvarRefreshToken(refreshToken: string): void {
        const { exp } = jwt_decode<{ exp: number }>(refreshToken)
        Cookies.set('refreshToken', refreshToken, {
            expires: new Date(exp * 1000),
            sameSite: 'lax',
        })
    }

    public logoff(redirect: boolean = true): void {
        Cookies.remove('JWT')
        Cookies.remove('refreshToken')
        Cookies.remove('tokenSuporte')
        if (redirect) window.location.href = '/'
    }
}

export default TokenRefresher.getInstance()
